import React from 'react'
import { TranslationsContext } from '../contexts/TranslationsContext'

export const useTranslate = () => {
	const appTranslations = React.useContext(TranslationsContext)
	return (key: string): string => {
		return appTranslations.primaryValues[key] || appTranslations.fallbackValues[key] || key
	}
}
